export default "__VITE_ASSET__AwzgSCCJ__"